import React, { useEffect, useState } from "react";
import Emitter from "../../common/emitter";
import {
	Snackbar,
	IconButton,
	CloseIcon,
} from "../../common/MaterialComponent";
import "./SnackbarMessage.css";

export const SnackbarMessage: React.FC = () => {
	const [open, setOpen] = useState(false);
	const [messageInfo, setMessageInfo] = useState("");
	const handleClose = (
		_event: React.SyntheticEvent | MouseEvent,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setOpen(false);
		setMessageInfo("");
	};
	useEffect(() => {
		Emitter.on("showSnackbarMessage", (message: string) => {
			if (message) {
				setOpen(true);
				setMessageInfo(message);
			}
		});
	}, []);

	return (
		<div>
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={open}
				onClose={handleClose}
				message={messageInfo}
				autoHideDuration={3000}
				action={
					<React.Fragment>
						<IconButton
							aria-label="close"
							color="inherit"
							onClick={handleClose}
							className="closeSnackbarIcon"
						>
							<CloseIcon />
						</IconButton>
					</React.Fragment>
				}
			/>
		</div>
	);
};
